<template>
  <div id="app" class="backgroundImage">
    <v-app style="background: rgba(0,0,0,0);color: #fff">
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <div>
              <v-form>
              <v-card class="mx-auto pa-10" max-width="500">
                <v-img src="@/assets/logo-primary.png" height="70px" contain class="mb-4" />
                <v-card-title class="title font-weight-regular justify-space-between">
                  <span>{{ currentTitle }}</span>
                  <v-avatar
                    color="primary lighten-2"
                    class="subheading white--text"
                    size="24"
                    v-text="step"
                  ></v-avatar>
                </v-card-title>
                <v-window v-model="step">
                  <v-window-item :value="1">
                    <v-card-text>
                      <v-text-field
                        v-model="form.email"
                        ref="email"
                        :rules="[rules.required, rules.email]"
                        label="E-mail"
                        name="login"
                        required
                      />
                      <v-checkbox v-model="termsAgreed">
                        <span slot="label">
                          I agree to the 
                          <a @click.stop href="https://apif.app/#/terms" target="_blank">Terms of Service</a>
                          and 
                          <a @click.stop href="https://apif.app/#/privacy" target="_blank">Privacy Policy</a>
                        </span>
                      </v-checkbox>
                    </v-card-text>
                  </v-window-item>
                  <v-window-item :value="2">
                    <v-card-text>
                      <v-text-field
                        v-model="form.password"
                        :rules="[rules.required, (form.password.length>=8) || 'Password needs to be at least 8 characters long']"
                        ref="password"
                        label="Password"
                        type="password"
                        required
                      />
                      <v-text-field 
                        v-model="confirmPassword"
                        :rules="[(form.password === confirmPassword) || 'Password must match']"
                        ref="passwordConfirm"
                        label="Confirm Password"
                        type="password"
                        required
                      />
                    </v-card-text>
                  </v-window-item>
                  <v-window-item :value="3">
                    <v-card-text>
                      <v-text-field 
                        v-model="form.firstName" 
                        label="First name"
                        name="firstName" />
                      <v-text-field 
                        v-model="form.lastName" 
                        label="Last name" 
                        name="lastName" />
                    </v-card-text>
                  </v-window-item>
                  <v-window-item :value="4">
                    <v-card-text>
                      <!--
                        <v-text-field
                          v-model="inviteCode"
                          label="Invitation code"
                          return-masked-value
                          mask="####-####"
                          type="text"
                        />
                        <v-btn
                          color="primary"
                          depressed
                          @click="checkCompanyInvites"
                          :disabled="!inviteCode"
                        >
                          {{ $t('submit') }}
                        </v-btn>
                      -->
                      <div v-if="invitesLoaded && invites.length">
                        <v-list two-line rounded>
                          <v-list-item-group v-model="inviteSelectedIndex" color="primary">
                            <v-list-item v-for="(item, i) in invites" :key="i">
                              <!--
                                <v-list-item-icon>
                                  <v-icon v-text="item.icon"></v-icon>
                                </v-list-item-icon>
                              -->
                              <v-list-item-content>
                                <v-list-item-title v-text="item.companyName" />
                                <v-list-item-subtitle>{{ $moment(item.added).format('YYYY-MM-DD') }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="invites.length" v-model="inviteDeclined" rounded>
                              <v-list-item-content>
                                <v-list-item-title>No, I don't want to join the company</v-list-item-title>
                                <v-list-item-subtitle>Decline the invite and initialize a new company</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </div>
                      <div v-if="!invitesLoaded">
                        <v-text-field color="primary" loading disabled />
                      </div>
                    </v-card-text>
                  </v-window-item>
                  <v-window-item :value="5">
                    <v-card-text>
                      <div v-if="!invites.length||(invitesLoaded && inviteDeclined)">
                        <v-text-field 
                          v-model="form.companyName"
                          :rules="[rules.required]"
                          ref="companyName"
                          label="Company name"
                          required
                        />
                        <v-text-field
                          v-model="form.companyNumber"
                          :rules="[rules.required, (!isNaN(form.companyNumber)) || 'Use only numbers']"
                          ref="companyNumber"
                          required
                          label="Company number"
                          type="number"
                        />
                      </div>
                      <div v-else>Something went wrong, contact tech support</div>
                    </v-card-text>
                  </v-window-item>
                  <v-window-item :value="6">
                    <v-card-text>Awesome, you're all set!</v-card-text>
                  </v-window-item>
                </v-window>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-btn
                    text
                    @click="step === 1 ? $router.push('signin') : step--"
                  >{{ step === 1 ? $t('back-to-sign-in') : $t('back') }}</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    depressed
                    @click="onNext"
                    :disabled="!isNextEnabled"
                  >{{ currentNextButton }}</v-btn>
                </v-card-actions>
              </v-card>
              </v-form>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app>
  </div>
</template>

<script>
export default {
  name: "SignIn",

  data() {
    return {
      step: 1,
      stepCreateAccount: 3,
      maxSteps: 6,
      termsAgreed: false,
      confirmPassword: '',
      form: {
        email: "",
        password: "",
        firstName: "",
        lastName: "",
        companyName: "",
        companyNumber: null,
      },
      rules: {
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
        businessEmail: (value) => {
          const pattern = /^[a-z0-9._%+-]+@(?!gmail.com|yahoo.com|ymail.com|hotmail.com)(?:[a-z0-9.-]+.?)+$/;
          return pattern.test(value) || "Use your business e-mail.";
        },
        confirmPassword: () => {
          return this.confirmPassword != this.form.password || "Oops, password does not match";
        },
      },
      error: null,
      //isNextEnabled: false,

      firebaseUser: null,
      inviteCode: null,
      invites: [],
      inviteSelectedIndex: null,
      inviteSelected: null,
      inviteDeclined: null,
      invitesLoaded: false,
    };
  },

  created() {
    this.$vuetify.theme.dark = false;

    if (this.$route.query.email) {
      this.form.email = this.$route.query.email;
    }
    if (this.$route.query.code) {
      this.inviteCode = this.$route.query.code;
    }
    if (this.$route.query.company) {
      this.form.companyName = this.$route.query.company;
    }
  },

  watch: {
    inviteSelectedIndex(val) {
      if (val > this.invites.length) {
        this.inviteSelected = null;
      } else {
        this.inviteSelected = this.invites[val];
      }
    },

  },

  computed: {
    currentTitle() {
      switch (this.step) {
        case 1:
          return "Sign-up";
        case 2:
          return "Create a password";
        case 3:
          return "User information";
        case 4:
          return "Invitations";
        case 5:
          return "Company information";
        default:
          return "Account created";
      }
    },
    currentNextButton() {
      switch (this.step) {
        case 3:
          return "Create account";
        case 6:
          return "Let's go";
        default:
          return "Next";
      }
    },
    getNextButtonText() {
      let txt = this.$t("next");
      if (this.step === this.stepCreateAccount) {
        txt = this.$t("create-account");
      }
      if (this.step === this.maxSteps) {
        txt = this.$t("start");
      }
      return txt;
    },
    isNextEnabled() {
      if (this.step === 1 && this.form.email && this.$refs.email && this.$refs.email.valid && this.termsAgreed ) {
        return true;
      }
      else if (this.step === 2 && this.form.password && this.confirmPassword && 
        this.$refs.password && this.$refs.password.valid && this.$refs.passwordConfirm && this.$refs.passwordConfirm.valid) {
        return true;
      }
      else if (this.step === 3 && this.form.firstName && this.form.lastName) {
        return true;
      }
      else if (this.step === 4 && this.inviteSelected || this.inviteDeclined) {
        return true;
      }
      else if (this.step === 5 && this.form.companyName && this.form.companyNumber && 
        this.$refs.companyName && this.$refs.companyName.valid && this.$refs.companyNumber && this.$refs.companyNumber.valid) {
        return true;
      }
      /*
      else if (this.step === 5 && this.form.companyName && 
        this.$refs.companyName && this.$refs.companyName.valid) {
        return true;
      }
      */
      else if (this.step === 6) {
        return true;
      }
      return false;
    },
    isNextDisabled() {
      if (this.step === 1 && !this.$refs.email && !this.$refs.email.valid && !this.termsAgreed && !this.form.email) {
        return true;
      }
      else if (this.step == 4 && !this.inviteSelected && !this.inviteDeclined) {
        return true;
      }
      return false;
    },
  },

  methods: {
    async onNext() {
      // create account
      if (this.step == this.stepCreateAccount) {
        this.createAccount();
      }

      // invites
      if (this.step == 4 && this.inviteSelected) {
        await this.joinCompany().then(() => {
          // jump over create company step
          this.step++;
        });
      }

      // create company
      if (this.step == 5 && !this.inviteSelected) {
        await this.createCompany();
      }

      if (this.step == this.maxSteps) {
        this.$router.replace("/");
      } else {
        this.step++;
      }
    },
    createAccount() {
      this.$authService
        .createNewAccount(this.form)
        .then((res) => {
          this.firebaseUser = res.user;
          this.checkCompanyInvites(res.user.email);
        })
        .catch((error) => {
          this.error = error;
        });
    },
    checkCompanyInvites(email) {
      this.$authService.checkInvites(email).then((res) => {
        this.invites = res;
        this.invitesLoaded = true;
        if (!this.invites.length) {
          this.step++;
        }
      });
    },
    async joinCompany() {
      if (this.inviteSelected) {
        return await this.$authService
          .acceptCompanyInvite(
            this.inviteSelected,
            this.inviteSelected.companyId,
            this.firebaseUser.uid,
            this.form.firstName,
            this.form.lastName,
            this.firebaseUser.email
          )
          .then(() => {
            return true;
          })
          .catch((error) => {
            console.log(error);
            this.error = error;
            return false;
          });
      } else {
        return false;
      }
    },
    async createCompany() {
      return await this.$authService
        .initCompanyAndProject(
          this.firebaseUser.uid,
          this.firebaseUser.email,
          this.form
        )
        .then(() => {
          return true;
        })
        .catch((error) => {
          console.log(error);
          this.error = error;
          return false;
        });
    },
  },
};
</script>

<style scoped>
.backgroundImage {
  /*background-image: url("https://images.pexels.com/photos/3551197/pexels-photo-3551197.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260");*/
  background-image: url("https://images.pexels.com/photos/1054218/pexels-photo-1054218.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260");
  background-size: cover;
}
#adminAuth .theme--light .v-main {
  background: none;
}

/* Change the white to any color ;) */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  box-shadow: 0;
  -webkit-box-shadow: 0 0 0 30px white inset !important;
}
</style>
